module.exports = __webpack_public_path__ + "static/media/connection.8dad174c.svg";